import React, {useEffect, useState} from 'react';
import * as ServerComms from '../utilities/ServerComms';
import PagePopUpTemplateSelector from './PagePopUpTemplateSelector';
import PreviousPagePopUpTemplateSelector from './PreviousPagePopUpTemplateSelector';

function App(props) {

  var isFEOrPU = props.isFEOrPU;

  var overallWidth = props.overallWidth;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var clickBack = props.clickBack;
  var setItemEdited = props.setItemEdited;
  var userNos = props.userNos;
  var width = props.width;
  var height = props.height;
  var userID = props.userID;
  var signKey = props.signKey;
  var sessionID = props.sessionID;
  var centerZoom = props.centerZoom;
  var chains = props.chains;
  var changeTab = props.changeTab;
  var feedSource = props.feedSource;
  var previousDApps = props.previousDApps;
  var palette = props.palette;

  var colorCombo = props.colorCombo;
  var setColorCombo = props.setColorCombo;
  var customColorRecord = props.customColorRecord;
  var setCustomColorRecord = props.setCustomColorRecord;
  var isShowingCustom = props.isShowingCustom;
  var setIsShowingCustom = props.setIsShowingCustom;

  const [templates, setTemplates] = useState([]);


  function getItemTemplates(){
    function postGetTemplates1(response){
      var ins = response.v.map((aN, index)=>{
        return {v:JSON.parse(aN.v[0].v), d:aN.v[1].v, as:JSON.parse(aN.v[2].v)};
      })
      setTemplates(ins);
    }
    if (feedSource > -1){
      ServerComms.fetchSomething({u:'getItemTemplates', feedSource, userID, signKey, sessionID}, postGetTemplates1);
    }
  }

  useEffect(()=>{
    getItemTemplates();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!currentList){
    return <div></div>
  }
//


  function handleChanges(uuid, changes, startingPanel){
      organicChanges(changes);
      setItemEdited({t:'screen', path:[isFEOrPU, uuid, '_s', startingPanel]});
      centerZoom();
      clickBack();
      clickBack();
  }
     
  var showWhat = null;
  if (feedSource === -1){
    var expressedWidth = width;
    if (width >= 768){
      expressedWidth = width * 5/12;
    }else{
      expressedWidth = width * 10/12;
    }

    showWhat = <PreviousPagePopUpTemplateSelector chains={chains} overallWidth={overallWidth} isFEOrPU={isFEOrPU} insetWidth={insetWidth} insetHeight={insetHeight} expressedWidth={expressedWidth} previousDApps={previousDApps} handleChanges={handleChanges} userNos={userNos} currentList={currentList} changeTab={changeTab}/>
  }else {
    showWhat = <PagePopUpTemplateSelector chains={chains} overallWidth={overallWidth} isFEOrPU={isFEOrPU} insetWidth={insetWidth} insetHeight={insetHeight} width={width} height={height} templates={templates} handleChanges={handleChanges} userNos={userNos} currentList={currentList} palette={palette} changeTab={changeTab}   colorCombo={colorCombo} setColorCombo={setColorCombo} customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom}  />
  }

  var addWhat;
  if (isFEOrPU === 'fe'){
    addWhat = 'Front End';
  }else{
    addWhat = 'Pop-Up';
  }
  
  return <div style={{width}}><center>
    <p className='lead mb-0'>Add {addWhat}</p>
    {showWhat}
    </center>
    </div>
}


//
export default App;
